class Blog {
	constructor( block ) {
		this.$block = $( block );
		this.$resourceWrapper = this.$block.ref( "resources" );
		this.$loadMore = this.$block.ref( "load-more" );

		this.ajaxMorePosts = undefined;
		this.env = {
			page: this.$block.data( "hm-next-page" ),
			category: this.$block.data( "hm-category" ),
			author: this.$block.data( "hm-author" )
		};

		this.$loadMore.off( "click" ).on( "click", this.loadMore.bind( this ) );
	}

	loaderState() {
		const self = this;
		let loadMoreText = "";

		return {
			load() {
				loadMoreText = self.$loadMore.text();

				self.$loadMore.attr( "disabled", true );
				self.$loadMore.text( "Loading..." );
			},
			success( resources ) {
				self.$loadMore.removeAttr( "disabled" );
				self.$loadMore.text( loadMoreText );

				self.$resourceWrapper.append( resources );
			},
			error() {
				self.$loadMore.removeAttr( "disabled" );
				self.$loadMore.text( loadMoreText );
			}
		};
	}

	loadMore( event ) {
		event.preventDefault();

		this.ajaxMorePosts = this.ajax();

		window.addEventListener( "popstate", ( event ) => {
			event.preventDefault();

			window.location.href = document.location;
		} );
	}

	ajax() {
		if ( this.ajaxMorePosts ) {
			return;
		}

		const loader = this.loaderState();

		return $.ajax( {
			url: hmGlobal.ajaxurl + "load-resources/",
			data: this.env,
			type: "POST",
			dataType: "json",
			beforeSend: () => {
				loader.load();
			},
			success: data => {
				if ( !data ) {
					return this.$loadMore.hide();
				}

				window.history.pushState( {}, "", `${ window.location.href.replace( /page\/\d+\//gm, "" ) }page/${ this.env.page }/` );

				loader.success( data.resources );

				if ( data.isLast ) {
					this.$loadMore.hide();
				} else {
					this.env.page += 1;
				}
			},
			error: ( jqXHR, textStatus, errorThrown ) => {
				loader.error();

				console.warn( jqXHR + " :: " + textStatus + " :: " + errorThrown );
			},
			complete: () => {
				this.ajaxMorePosts = undefined;
			}
		} );
	}
}

export default Blog;
